<template>
  <div class="content" v-show="!isLoading">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33"
      >
        <stats-card
          :data-background-color="
            pendingPayments.length > 0 && isDueMonth ? 'red' : 'primary'
          "
        >
          <template slot="header">
            <md-icon>credit_card</md-icon>
          </template>

          <template slot="content">
            <div v-if="pendingPayments.length > 0 && isDueMonth">
              <router-link to="/history" style="color: #E94441;">
                <p class="category">
                  Sua conta de
                  {{ getMonthName(formatDate(pendingPayments[0].date)) }}
                  não está paga
                </p>

                <h3 class="title">R$ {{ pendingPayments[0].price }}</h3>
              </router-link>
            </div>
            <div v-else>
              <p class="category">Você não possui débitos pendentes</p>
              <h3 class="title"><md-icon>sentiment_very_satisfied</md-icon></h3>
            </div>
          </template>

          <template slot="footer">
            <div class="stats">
              <div v-if="pendingPayments.length > 0 && isDueMonth">
                <md-icon>date_range</md-icon>
                Vencimento em {{ pendingPayments[0].date }}
              </div>
              <div v-else-if="pendingPayments.length > 0 && !isDueMonth">
                <md-icon>date_range</md-icon>Próxima fatura em
                {{ pendingPayments[0].date }}
              </div>
              <div v-else>
                <md-icon>date_range</md-icon>Atualizado à 2 minutos atrás
              </div>
            </div>
          </template>
        </stats-card>
      </div>
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33"
      >
        <stats-card data-background-color="secondary">
          <template slot="header">
            <md-icon>support_agent</md-icon>
          </template>

          <template slot="content">
            <p class="category">Atendimentos</p>
            <h3 class="title">
              {{ ticketsCount }}
              <small>aberto no total</small>
            </h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon class="text-success">edit</md-icon>
              <router-link to="/tickets/create" class="text-main"
                >Abrir um atendimento</router-link
              >
            </div>
          </template>
        </stats-card>
      </div>
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33"
      >
        <stats-card>
          <template slot="header">
            <md-icon>wifi_tethering</md-icon>
          </template>

          <template slot="content">
            <p class="category">Serviços contratados</p>
            <h3 class="title">{{ points.length }}</h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>date_range</md-icon>Atualizado à 2 minutos atrás
            </div>
          </template>
        </stats-card>
      </div>

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <md-card>
          <md-card-header data-background-color="primary">
            <h4 class="title">Serviços</h4>
            <p class="category">Segue abaixo informações de seus serviços</p>
          </md-card-header>
          <md-card-content>
            <md-table v-model="pointsModel" :table-header-color="'green'">
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Plano">{{
                  item.plan_name
                }}</md-table-cell>
                <md-table-cell md-label="Endereço">{{
                  formatAddressShort(item)
                }}</md-table-cell>
                <md-table-cell md-label="Status">
                  <span
                    :class="[
                      { badge: true },
                      formatStatusBadgeColor(item.status)
                    ]"
                    >{{ formatStatus(item.status) }}</span
                  >
                </md-table-cell>
                <md-table-cell md-label="Visualizar">
                  <router-link to="/services">
                    <md-icon>open_in_new</md-icon>
                  </router-link>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
        </md-card>
      </div>

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <md-card>
          <md-card-header data-background-color="primary">
            <h4 class="title">Contratos Assinados</h4>
            <p class="category">Segue abaixo seus contratos</p>
          </md-card-header>
          <md-card-content>
            <md-table v-model="links" :table-header-color="'green'">
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="ID">{{ item.id }}</md-table-cell>
                <md-table-cell md-label="Nome">
                  {{ item.name || item.template.name }}
                </md-table-cell>
                <md-table-cell md-label="Assinado">
                  {{ format(item.signedAt || item.signed_at) }}
                </md-table-cell>
                <md-table-cell md-label="Visualizar">
                  <a
                    href="#"
                    @click="openContract(item.id)"
                    v-if="item.signedAt"
                  >
                    <md-icon>file_download</md-icon>
                  </a>
                  <a
                    :href="
                      `${gerenariUrl}/api/sign-contract?contract_id=${
                        item.id
                      }&access_token=${userToken()}`
                    "
                    target="_blank"
                    v-else
                  >
                    <md-icon>file_download</md-icon>
                  </a>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { mapActions } from "vuex";
import { StatsCard, OrderedTable } from "@/components";
import {
  format,
  getMonthName,
  formatDate,
  formatMoney,
  formatStatus,
  formatAddressShort,
  formatStatusBadgeColor
} from "@/helpers";

export default {
  components: {
    StatsCard
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    points() {
      return this.$store.getters.points;
    },
    ticketsCount() {
      return this.$store.getters.ticketsCount;
    },
    tickets() {
      return this.$store.getters.tickets;
    },
    pendingPayments() {
      return this.$store.getters.pendingPayments;
    },
    contracts() {
      return this.$store.getters.signedContracts;
    },
    userid() {
      return this.$store.getters.user.id;
    },
    gerenariUrl() {
      return "https://app.hubnari.com.br";
    },
    isDueMonth() {
      if (this.pendingPayments.length === 0) {
        return false;
      }

      const today = new Date();
      const dueDate = new Date(formatDate(this.pendingPayments[0].date));

      const oneDay = 24 * 60 * 60 * 1000;
      const diffDays = Math.round(Math.abs((dueDate - today) / oneDay));

      return (
        diffDays <= 15 ||
        today.getFullYear() > dueDate.getFullYear() ||
        (today.getFullYear() == dueDate.getFullYear() &&
          today.getMonth() > dueDate.getMonth())
      );
    }
  },
  data() {
    return {
      isLoading: false,
      pointsModel: [],
      links: []
    };
  },
  methods: {
    ...mapActions([
      "fetchPoints",
      "fetchPendingPayments",
      "fetchTickets",
      "countTickets",
      "fetchContracts",
      "openContract"
    ]),
    format,
    getMonthName,
    formatDate,
    formatStatus,
    formatStatusBadgeColor,
    formatMoney,
    formatAddressShort,
    userToken() {
      return localStorage.getItem("gerenariAccessToken");
    }
  },
  async mounted() {
    const isPossibleFirstLoad =
      this.pendingPayments.length === 0 && this.points.length === 0;

    let loader = null;
    if (isPossibleFirstLoad) {
      this.isLoading = true;
      loader = this.$loading.show({
        color: "#A9CD84",
        lockScroll: true,
        container: this.$refs.formContainer,
        canCancel: false
      });
    }

    this.pointsModel = this.points;

    await Promise.all([
      this.fetchContracts({ id: this.userid }),
      this.countTickets(),
      this.fetchTickets(),
      this.fetchPoints({ id: this.user.id }),
      this.fetchPendingPayments({ taxId: this.user.taxId })
    ]);

    this.pointsModel = this.points;
    this.links = this.contracts;

    if (loader) {
      this.isLoading = false;
      loader.hide();
    }

    if (this.pendingPayments.length > 0 && this.isDueMonth) {
      const result = await Swal.fire({
        title: "Atenção!",
        text: "Você possui fatura em aberto, deseja baixa-la?",
        icon: "warning",
        focusConfirm: false,
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#9dcf6b",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        allowOutsideClick: false
      });

      if (result.isConfirmed) {
        window.open(
          `https://api.globalfibra.com.br/app/download?link=${this.pendingPayments[0].link}`,
          "_blank"
        );
      }
    }
  }
};
</script>

<style scoped>
.text-main {
  color: var(--primary-color) !important;
}
</style>
